'use strict';

intellidealerAppCoreModule.factory('partSubsResource', function ($resource, appConfigurationService) {
  return {
    myDealerCustomerPartSubDetailsByPart: $resource(appConfigurationService.basePath + '/rest/partsubs/myDealerCustomerPartSubDetailsByPart/'),
    myDealerCustomerPartSubDetailsByPartAndLocation: $resource(appConfigurationService.basePath + '/rest/partsubs/myDealerCustomerPartSubDetailsByPartAndLocation/')
  }
});
